import { Component, OnInit, OnDestroy } from '@angular/core';
import { HotelDetailGQL } from './hotel-detail.graphql';
import { property_property_images, property_property_roomTypes } from './types/property';
import { Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { property_property } from './types/property';
import { environment } from 'src/environments/environment';
import { Slide } from 'src/app/shared/components/mosaic/mosaic.inferface';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { formatInTimeZone } from 'date-fns-tz'
import { Observable } from 'rxjs';
import { GoogleMapStyles } from 'src/app/shared/config/googleMaps.config';
import { Title } from '@angular/platform-browser';
import { Meta } from '@angular/platform-browser';
import { LinkService } from './../../../shared/services/link.service';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-hotel-details',
  templateUrl: './hotel-details.component.html',
  styleUrls: ['./hotel-details.component.scss']
})
export class HotelDetailsComponent implements OnInit, OnDestroy {
  private propertySubscription: Subscription;
  private routeSubscription: Subscription;
  loading: boolean = true;
  property: property_property;
  propertySlug: string;
  slides: Slide[] = [];
  google_api_key: string = environment.google_api_key;
  assets_base: string = environment.assets_base;
  options: UntypedFormGroup;
  selectedDateRange: any;
  apiLoaded: Observable<boolean>;
  roomTypes: property_property_roomTypes[] = [];
  attractions: property_property_images[] = [];

  googleMapOptions: google.maps.MapOptions = {
    styles: GoogleMapStyles
  }

  markerOptions: google.maps.MarkerOptions = {
    draggable: false,
    icon: 'assets/images/map-marker-blue.png'
  }

  constructor(fb: UntypedFormBuilder,
    private hotelDetailGQL: HotelDetailGQL,
    private route: ActivatedRoute,
    private titleService: Title,
    private meta: Meta,
    private linkService: LinkService) {
    this.routeSubscription = this.route.paramMap.subscribe(params => {
      this.propertySlug = params.get('hotelId');
      if(this.propertySlug)  {
        this.getProperty();
      }
    });

    this.options = fb.group({
      checkin: new UntypedFormControl(null),
      checkout: new UntypedFormControl(null),
      rooms: new UntypedFormControl(1),
      adults: new UntypedFormControl(1),
      children: new UntypedFormControl(0),
      promo: new UntypedFormControl(null),
      webUrl: new UntypedFormControl(null),
    });
  }

  ngOnInit(): void {}

  getAdults(adults: number) {
    this.options.patchValue({
      adults: adults
    });
  }

  getChildren(children: number) {
    this.options.patchValue({
      children: children
    });
  }

  getProperty() {
    const hasSlug = this.propertySlug.match(/^[0-9]+$/) == null;
    this.propertySubscription = this.hotelDetailGQL
    .watch({
      code: !hasSlug ? this.propertySlug : undefined,
      slug: hasSlug ? this.propertySlug : undefined
    })
    .valueChanges
    .pipe(take(1))
    .subscribe(({ data, loading }) => {
      this.loading = loading;
      if (data.property === null) {
      } else {
        this.property = data.property;
        this.attractions = this.property.images
        .filter(entry => entry.accessCode === '003');
        this.roomTypes = this.roomTypes.length ? this.property.roomTypes.filter(entry => entry.status === 'ACTIVE') : [];
        this.getFeaturedImages('004');

        this.titleService.setTitle(`${this.property.property.name}, ${this.property.property.city}`);
        this.meta.addTags([  
          { name: 'title', content: `${this.property.property.name}, ${this.property.property.city} - Hotel Book Direct` },
          { name: 'description', content: this.property.property.description },
          { name: 'robots', content: 'index, follow' }
        ]);

        this.linkService.addTag( { rel: 'canonical', href: 'https://fairbridgeinns.com/hotel/'+this.property.property?.slug} );
      }
    });
  }

  getFeaturedImages(accessCode: string) {
    this.slides = this.property.images
    .filter(entry => entry.accessCode === accessCode || entry.accessCode === '001')
      .map(entry => {
        return {
          src: entry.amazonS3Url,
          headline: entry.caption,
          accessCode: entry.accessCode
        };
      }).sort((a, b) => {
        if (a.accessCode > b.accessCode) {
          return 1;
        }
          return -1;
      });
  }

  bookNow() {
    this.options.patchValue({
      checkin: formatInTimeZone(new Date(this.selectedDateRange.startDate.$d), 'UTC', 'yyyy-MM-dd'),
      checkout: formatInTimeZone(new Date(this.selectedDateRange.endDate.$d), 'UTC', 'yyyy-MM-dd')
    })
    let params = [];
    if(this.options.value.checkin && this.options.value.checkout) {
      params.push('checkin=' + this.options.value.checkin);
      params.push('checkout=' + this.options.value.checkout);
    }
    if(this.options.value.rooms) {
      params.push('rooms=' + this.options.value.rooms);
    }
    if(this.options.value.adults) {
      params.push('adults=' + this.options.value.adults);
    }
    if(this.options.value.children) {
      params.push('children=' + this.options.value.children);
    }
    if(this.options.value.promo) {
      params.push('promo=' + this.options.value.promo);
    }

    let bookNowURL = this.property.property.webUrl;
    if (bookNowURL) {
      if(params.length) {
        bookNowURL = bookNowURL + '&' + params.join('&');
      }
      window.location.href = bookNowURL;
    }
  }

  ngOnDestroy() {
    this.routeSubscription.unsubscribe();
    this.propertySubscription.unsubscribe();
  }
}
